module.exports = __webpack_public_path__ + "static/img/logo.a106107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 146
// module chunks = 171